import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueTailwind from 'vue-tailwind'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import "./assets/scss/app.scss";
import './assets/tailwind.css'
import "./plugins/vuetify-money.js";
import Maska from 'maska';
Vue.use(Maska);
Vue.use(VueSweetalert2);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  VueTailwind,
  render: h => h(App)
}).$mount('#app')
